import { useController, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Preview from "./Preview";
import { cn } from "../../../../../../../lib/utils";
import { colorOptions } from "./colors";

function Shift() {
    const { t } = useTranslation();
    const { control } = useFormContext();
    const caseDisplay = useWatch({ control, name: "shiftCaseDisplay" }) ?? "normal";
    const { field } = useController({ control, name: "colors.regular" });

    const selected: number = field.value ?? 0;
    const { bg, border } = colorOptions[selected] ?? colorOptions[0];

    return (
        <div className="tw-flex tw-flex-col tw-gap-2">
            <span className="tw-text-sm tw-font-medium tw-text-foreground">{t("shift-type-colors")}</span>
            <div className="tw-flex tw-items-center tw-gap-3 tw-py-2.5">
                <div className="tw-flex tw-gap-1.5 tw-shrink-0">
                    {colorOptions.map((opt, i) => (
                        <button
                            key={i}
                            type="button"
                            onClick={() => field.onChange(i)}
                            className={cn(
                                "tw-w-5 tw-h-5 tw-rounded-full tw-border tw-transition-all tw-cursor-pointer",
                                selected === i
                                    ? "tw-ring-2 tw-ring-offset-1 tw-ring-foreground/60 tw-scale-110"
                                    : "hover:tw-scale-110",
                            )}
                            style={{ backgroundColor: opt.bg, borderColor: opt.border }}
                        />
                    ))}
                </div>
                <Preview
                    bg={bg}
                    border={border}
                    caseDisplay={caseDisplay}
                    label={t("regular")}
                />
            </div>
        </div>
    );
}

export default Shift;
